<script setup lang="ts">
const { t } = useI18n()
const config = useRuntimeConfig()

const expressShippingTime = computed(() => {
  const min = +config.public.expressShippingTime.min
  const max = +config.public.expressShippingTime.max
  return {
    min,
    max,
  }
})
</script>

<template>
  <div class="mx-auto max-w-5xl px-4">
    <div class="mb-4 rounded-md bg-[#F9E8D8] p-2">
      <div class="flex items-center justify-center">
        <div class="flex items-center space-x-3">
          <Icon name="lucide:truck" class="size-8 text-black" />
          <div>
            <h3 class="text-sm text-black fw600">
              {{ t('why_uzo.guarantees.free_shipping.title') }}
            </h3>
            <p class="mt-0.5 text-sm text-muted-foreground">
              {{ t('delivery.within_n_days', [expressShippingTime.min]) }}
            </p>
          </div>
        </div>

        <div class="mx-4 h-15 w-px bg-gray-400" />
        <NuxtLinkLocale to="/why-uzo">
          <div class="flex items-center space-x-3">
            <Icon name="lucide:lock" class="size-8 text-black" />
            <div>
              <h3 class="text-base text-black fw600">
                {{ t('general.safe_buy.label') }}
              </h3>
              <p class="mt-0.5 text-sm text-muted-foreground">
                {{ t('general.our_values.label') }}
              </p>
            </div>
          </div>
        </NuxtLinkLocale>
      </div>
    </div>

    <NuxtLinkLocale to="/why-uzo">
      <div class="flex cursor-pointer items-center justify-between rounded-md bg-success px-4 py-2">
        <div class="flex items-center space-x-3">
          <div class="flex items-center rounded-full bg-white/10 p-1">
            <Icon name="lucide:shield-check" class="size-7 rounded-full p-2 text-white" />
          </div>
          <span class="text-base text-white fw600">{{ t('general.why_choose_uzo') }}</span>
        </div>
        <div class="flex items-center space-x-3">
          <Icon name="lucide:chevron-right" class="text-3xl text-white" />
        </div>
      </div>
    </NuxtLinkLocale>
  </div>
</template>
